import { ConversationalChatVisibility, LoginStatus, Platform } from '@klant/conversational-connector/klant-conversational-connector.model';
import { ConversationalConnectorAnalyticsService } from '@klant/conversational-connector/services/analytics/analytics.service';

import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';

import { ApContentService } from '@ap/content';
import { ApError } from '@ap/error';

import { ChatSessionStore } from '../../signal-stores/chat-session-store/chat-session.store';
import { ConversationalChatStore } from '../../signal-stores/conversational-chat-store/conversational-chat.store';
import { ConversationalConfigStore } from '../../signal-stores/conversational-config-store/conversational-config.store';

import content from './retail-klant-conversational.content.json';

@Component({
    selector: 'retail-klant-conversational',
    templateUrl: './retail-klant-conversational.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RetailKlantConversationalComponent {
    private readonly apContentService = inject(ApContentService);
    private readonly chatSessionStore = inject(ChatSessionStore);
    private readonly conversationalChatStore = inject(ConversationalChatStore);
    private readonly conversationalConnectorAnalyticsService = inject(ConversationalConnectorAnalyticsService);
    private readonly conversationalConfigStore = inject(ConversationalConfigStore);

    public readonly showConnector = computed(() => !this.showError() && this.isOperational() === true);
    public readonly showError = computed(() => {
        return (
            this.doneLoading() &&
            (this.conversationalChatStore.takeoverError() ||
                this.chatSessionStore.errorGettingChatSessionIdChat() ||
                this.isOperational() === false)
        );
    });

    private readonly doneLoading = this.conversationalConfigStore.doneLoading;
    private readonly isOperational = this.conversationalConfigStore.isOperational;

    private readonly shouldInitializeAnonymousChat = computed(() => {
        return (
            this.conversationalChatStore.chatVisibility() === ConversationalChatVisibility.OPEN &&
            this.isOperational() === true &&
            !this.chatSessionStore.chatSession()
        );
    });
    public readonly takeoverError = computed(() => {
        return (
            this.conversationalChatStore.takeoverError() ??
            new ApError(this.apContentService.get('retail.klant.conversational.takeover.error.message'), '', undefined, false)
        );
    });

    public constructor() {
        this.apContentService.addContentItems(content);
        this.conversationalChatStore.setPlatform(Platform.RETAIL);

        effect(() => {
            if (this.shouldInitializeAnonymousChat()) {
                this.initializeAnonymousChat();
            }
        });
    }

    private initializeAnonymousChat(): void {
        this.conversationalConnectorAnalyticsService.pushAnalyticsPageview(LoginStatus.ANONYMOUS);
        this.chatSessionStore.patchChatSession({ loginStatus: LoginStatus.ANONYMOUS });
    }

    public conversationalChatVisibilityChanged(chatVisibility: ConversationalChatVisibility): void {
        this.conversationalChatStore.setChatVisibility(chatVisibility);
    }
}
